function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "13BE7F9B-B363-4D4D-B050-A6C2625426BD");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M1.12829232,15.3941388 L13.3533834,21.8584856 L25.5784745,15.3941388 C25.7840453,15.2854377 26.0388131,15.3639661 26.1475142,15.5695369 C26.2562153,15.7751077 26.1776869,16.0298755 25.9721161,16.1385766 L13.5502042,22.7069977 C13.4270679,22.7721094 13.279699,22.7721094 13.1565626,22.7069977 L0.734650768,16.1385766 C0.529079954,16.0298755 0.450551546,15.7751077 0.55925266,15.5695369 C0.667953774,15.3639661 0.922721509,15.2854377 1.12829232,15.3941388 Z M1.12829232,11.4173394 L13.3533834,17.8816862 L25.5784745,11.4173394 C25.7840453,11.3086383 26.0388131,11.3871667 26.1475142,11.5927375 C26.2562153,11.7983083 26.1776869,12.0530761 25.9721161,12.1617772 L13.5502042,18.7301983 C13.4270679,18.79531 13.279699,18.79531 13.1565626,18.7301983 L0.734650768,12.1617772 C0.529079954,12.0530761 0.450551546,11.7983083 0.55925266,11.5927375 C0.667953774,11.3871667 0.922721509,11.3086383 1.12829232,11.4173394 Z M13.1565627,0.604020168 C13.279699,0.538908507 13.4270679,0.538908507 13.5502043,0.604020168 L25.9721162,7.17244137 C26.271092,7.3305329 26.271092,7.75878764 25.9721162,7.91687916 L13.5502043,14.4853004 C13.4270679,14.550412 13.279699,14.550412 13.1565627,14.4853004 L0.734650769,7.91687916 C0.435674964,7.75878764 0.435674964,7.3305329 0.734650769,7.17244137 L13.1565627,0.604020168 Z M24.8745507,7.54465997 L13.3533836,1.45253222 L1.83221644,7.54465997 L13.3533836,13.6367877 L24.8745507,7.54465997 Z",
  id: "path-123"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Users",
  transform: "translate(-1017.000000, -122.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings-not-selected",
  transform: "translate(1014.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Settings"
}, /*#__PURE__*/React.createElement("g", {
  id: "Color/Primary/Brand",
  transform: "translate(2.526316, 4.210442)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-24",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-123"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#EAECF0",
  fillRule: "nonzero",
  xlinkHref: "#path-123"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-24)",
  id: "Rectangle-Copy-3"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2.526316, -4.210526)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 32,
  height: 32
}))))))))));

var SvgSubscriptions = function SvgSubscriptions(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "23px",
    viewBox: "0 0 26 23",
    fill: "#9FA5B7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubscriptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Subscriptions.936df542.svg";
export { ForwardRef as ReactComponent };